import type { IMasterDataProductUomRepository } from "@src/domain/repositories/masterData";
import type { DeleteMasterDataProductUomsDTO } from "@src/domain/dto/masterData";

export class DeleteMasterDataProductUomsUseCase {
  private readonly repository: IMasterDataProductUomRepository;

  constructor(repository: IMasterDataProductUomRepository) {
    this.repository = repository;
  }

  execute(params: DeleteMasterDataProductUomsDTO) {
    return this.repository.deleteProductUoms(params);
  }
}
